import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'

import SignIn from './SignIn'
import SignUpRegisterNumber from './SignUpRegisterNumber'
import SignUpVerifyNumber from './SignUpVerifyNumber'
import SignUpRegisterDetails from './SignUpRegisterDetails'
import SignUpSetPassword from './SignUpSetPassword'
import ForgottenPassword from './ForgottenPassword'
import ForgottenPasswordAuth from './ForgottenPasswordAuth'
import ForgottenPasswordNewPassword from './ForgottenPasswordNewPassword'
import Help from '../Help'
import SignUpNewCustomerSim from './SignUpNewCustomerSim'
import SignUpNewCustomerDetails from './SignUpNewCustomerDetails'
import SignUpNewCustomerOTP from './SignUpNewCustomerOTP'
import CameraComponent from './CameraComponent'
import RegistrationHome from './RegistrationHome'
import RegisterNewCustomerConfirmation from './RegisterNewCustomerConfirmation'
import NcaScanId from './NcaScanId'
import SignUpRegisterICCID from './SignUpRegisterICCID'
const Stack = createNativeStackNavigator()

function SignNavigator() {
  return (
    <Stack.Navigator
      initialRouteName='SignIn'
      screenOptions={{
        gestureEnabled: true,
        headerShown:false,
      }}
    >
      <Stack.Screen
        name="SignIn"
        component={SignIn}
      />
      <Stack.Screen
        name="RegisterNumber"
        component={SignUpRegisterNumber}
      />
      <Stack.Screen
        name="RegisterICCID"
        component={SignUpRegisterICCID}
      />
      <Stack.Screen
        name="VerifyNumber"
        component={SignUpVerifyNumber}
      />
      <Stack.Screen
        name="RegisterDetails"
        component={SignUpRegisterDetails}
      />
      <Stack.Screen
        name="SetPassword"
        component={SignUpSetPassword}
      />
      <Stack.Screen
        name="ForgottenPassword"
        component={ForgottenPassword}
      />
      <Stack.Screen
        name="ForgottenPasswordAuth"
        component={ForgottenPasswordAuth}
      />
      <Stack.Screen
        name="ForgottenPasswordNewPassword"
        component={ForgottenPasswordNewPassword}
      />
      <Stack.Screen
        name="Help"
        component={Help}
      />
      <Stack.Screen
        name="SignUpNewCustomerSim"
        component={SignUpNewCustomerSim}
      />
      <Stack.Screen
        name="SignUpNewCustomerDetails"
        component={SignUpNewCustomerDetails}
      />
      <Stack.Screen
        name="SignUpNewCustomerOTP"
        component={SignUpNewCustomerOTP}
      />
      <Stack.Screen
        name="CameraComponent"
        component={CameraComponent}
      />
      <Stack.Screen
        name="RegistrationHome"
        component={RegistrationHome}
        options={{gestureEnabled: false}}
      />
      <Stack.Screen
        name="RegisterNewCustomerConfirmation"
        component={RegisterNewCustomerConfirmation}
      />
      <Stack.Screen
        name="NcaScanId"
        component={NcaScanId}
      />
    </Stack.Navigator>
  )
}

export default SignNavigator
